import { useNavigate } from 'react-router-dom';

const useRedirectToLogin = () => {
  const navigate = useNavigate();

  return (redirect = false, url: string | null = null) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    let link = '/auth/login';

    if (!window.location.pathname.startsWith('/auth')) {
      let continueLink = window.location.href;
      if (url) {
        continueLink = url;
      }
      link = `/auth/login/?continue=${encodeURIComponent(btoa(continueLink))}`;
    }

    if (redirect) {
      void navigate(link, { replace: true });
    }

    return link;
  };
};

export default useRedirectToLogin;
